export default __webpack_public_path__ + "files/377564d283f9bc35cce974f33e37eaf3.png";